<script>
  import _ from 'lodash'
  import ThemeQuestionAnswerField from '../components/theme-question-answer-field'

  export default {
    template: '#theme-question-field-template',
    name: 'ThemeQuestionField',
    components: {
      'theme-question-answer-field': ThemeQuestionAnswerField
    },
    props: {
      id: Number,
      type: String,
      onAnswerChanged: Function,
      premiseQuestions: {
        type: Array
        /*
          @example
          [{
            "question": <<question_id>>,
            "option": <<option_id>>,
            "satisfied": <<true or false>>
          }]
         */
      },
      initOutputType: String
    },
    data () {
      return {
        show: true,
        outputType: this.initOutputType,
        children: null,
      }
    },
    watch: {
      show (newValue, oldValue) {
        // 依存問題の表示制御
        _.forEach(this.searchDependentQuestions(), (question) => {
          question.show = newValue && question.isPremiseQuestionsSatisfied()
        })

        // 前提問題の表示に合わせる
        this.show = this.show && _.every(this.searchPremiseQuestions(), (question) => question.show)
      },
      outputType: {
        immediate: true
      },
    },
    computed: {},
    mounted () {
      this.children = this.getThemeQuestionAnswerField()
      this.show = this.isPremiseQuestionsSatisfied()
    },
    methods: {
      getThemeQuestionAnswerField() {
        const children = []
        const keys = Object.keys(this.$refs)
        for ( let i = 0; i < keys.length; i++) {
          const key = keys[i]
          if (key.startsWith('themeQuestionAnswerFieldRef')) {
            children.push(this.$refs[key])
          }
        }
        return children
      },
      onAnswerChange (answer) {
        this.$parent.onAnswerChange(answer)
      },

      isPremiseQuestionsSatisfied () {
        return _.isEmpty(this.premiseQuestions) || _.some(this.premiseQuestions, { satisfied: true })
      },

      searchDependentQuestions () {
        return _.filter(this.$parent.children, { premiseQuestions: [{ question: this.id }] })
      },

      searchPremiseQuestions () {
        const condition = _.map(this.premiseQuestions, 'question')
        return _.filter(this.$parent.children, (q) => { return _.includes(condition, q.id) })
      },
    },
  }
</script>
